module.exports = __webpack_public_path__ + "img/black_elegant_leather_jacket-400x520.fa25afe3.jpg";